/* eslint-disable react-native/no-inline-styles */
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import { Col, Row, Button, Modal } from "react-bootstrap";
import { IoEyeOutline } from "react-icons/io5";
import Divider from '@mui/material/Divider';
import {
  fetchPDPInitialLoad,
  fetchPDPBidCenterData,
  fetchPDPLatestBidCenterData,
} from "@/redux/PDP/pdpSlice";


const PropertyInfoDetails = ({
  properttInfoData,

}) => {
  const pdpInitData = useSelector(state => state.pdp?.pdpInitData);

  const propertyInfo = pdpInitData?.propertyDetails?.propertyInformation;

// const formattedtTxt = propertyInfo.split(/\r?\n/).map((line, index) => (
//   <p className= 'pdpBody3' key={index}>{line}</p>
// ));


  return (

 <div className="propertyInfoBox mb30 tour-pdp-details p0">
                <Row className="propertyInfoBoxHeading p0" 
                style={{padding:0}}>
                    <h3 className='propertyInfoBoxHeadingText' >
                         Property Information
                    </h3>

                </Row>
    {/* <div className="propertyInfoBox mb30 tour-pdp-details p0">

      <Row className="propertyInfoBoxHeading p0">
        <h3 className='propertyInfoBoxHeadingText' >
          Property Information
        </h3>

      </Row> */}

      <div className='p30' style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>


        <div >

                      <div dangerouslySetInnerHTML={{ __html: pdpInitData?.propertyDetails?.propertyInformation }}></div>

          {/* <div className='pdpBody3' style={{color:'black'}}>

            {              
              formattedtTxt
              }



          </div> */}
        </div>
        <div />
      </div>


    </div>
  );
};

export default PropertyInfoDetails;

